import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  sitecoreItemByIdQuery,
  type GraphqlJSSField,
  type ScValue,
  type SitecoreItemByIdResponse,
} from '@core/jss-graphql';
import { map, type Observable } from 'rxjs';

const suiteCrmFormNames: string[] = [
  'inhomeadviesgesprek',
  'bespaarcoach_isolatie',
  'isolatietest_adviesgesprek_website',
  'yellowonline_isolatietest_adviesgesprek_website',
  'ventilatie_aanvraagformulier_website',
  'isolatietest_adviesgesprek',
  'bespaarcoach_zonnepanelen',
  'spaarpanelen',
  'spaarpanelen_mm',
  'zonnepanelen_check',
  'yellowonline_zonnepanelen_check',
  'spaarpanelen_obc',
  'energieplus',
];

export type FormIntegration = {
  formName: string | null;
};

@Injectable({
  providedIn: 'root',
})
export class GenericFormSubmitFlowService {
  private readonly httpClient = inject(HttpClient);

  public getFormIntegration(templateId: string): Observable<FormIntegration> {
    const variables = {
      templateId,
    };
    return this.httpClient
      .post<SitecoreItemByIdResponse>(
        '/graphql',
        JSON.stringify({
          query: sitecoreItemByIdQuery,
          variables,
        }),
        { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
      )
      .pipe(map((body) => this.mapToFormIntegration(body)));
  }

  public isSuiteCrmForm(form: FormIntegration): boolean {
    const formName = form.formName?.toLowerCase() ?? '';
    return suiteCrmFormNames.includes(formName);
  }

  private mapToFormIntegration(
    body: SitecoreItemByIdResponse
  ): FormIntegration {
    const reducer = (acc: string | null, cur: GraphqlJSSField) =>
      cur.name === 'FormName' ? (cur.jss as ScValue | null)?.value : acc;

    return { formName: (body.data?.item?.fields ?? []).reduce(reducer, null) };
  }
}
